import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import {
  AlarmDetails,
  AlarmEventInterval,
  CurrentAlarms,
} from "../../../modules/alarms/types";

const ROUTE = "/Alarms";

//Get Alarm Details
export async function getAlarms(): Promise<{
  data: AlarmDetails[];
  total: number;
}> {
  // page: number = 1,
  // search: string = "",
  // params?: Partial<Client>,
  // limit: number = 1000
  //TODO: Aplicar parâmetros quando a paginação e ordenação do Back End estiver finalizada

  const config: AxiosRequestConfig = {
    // params: {
    //   _page: page,
    //   _limit: limit,
    //   q: search,
    //   ...params,
    // },
  };

  const result = await api.get<AlarmDetails[]>(`${ROUTE}/all-alarms`, config);
  return {
    data: result.data,
    total: parseInt(result.headers["x-total-count"]),
  };
}
export async function getAlarmDetails(code: string): Promise<AlarmDetails> {
  const result = await api.get(`${ROUTE}/details/${code}`);
  return result.data.alarm;
}

// Get Alarm Timeline
export async function getAlarmTimeline(
  usinaId: string,
  ug: string,
  area: string,
  code: string,
  interval: AlarmEventInterval,
  numeroString?: number
) {
  const config: AxiosRequestConfig = {
    params: {
      usinaId: usinaId,
      ug: ug,
      area: area,
      code: code,
      interval: interval,
      numeroString: numeroString
    },
  };
  const result = await api.get(`${ROUTE}/timeline`, config);
  return result.data;
}

export async function patchNameAlarm(
  code: string,
  name: string
): Promise<AlarmDetails> {
  const result = await api.patch(`${ROUTE}/name/${code}?name=${name}`);
  return result.data.alarm;
}

export type PatchAlarmDetails = {
  specializedTechnical?: string;
  technicalAssistance?: string;
  provider?: string;
  dealership?: string;
};
//Patch Alarm Details
export async function patchAlarmDetails(
  code: string,
  alarmDetails: PatchAlarmDetails
) {
  const result = await api.patch(`${ROUTE}/details/${code}`, alarmDetails);
  return result.data.alarm;
}

//Patch Severity
export async function patchSeverity(
  code: string,
  severity: number
): Promise<AlarmDetails> {
  const result = await api.patch(
    `${ROUTE}/severity/${code}?severity=${severity}`
  );
  return result.data.alarm;
}

//Patch Possible Causes
export async function patchPossibleCauses(
  code: string,
  possibleCauses: string
): Promise<AlarmDetails> {
  console.log(possibleCauses);
  const result = await api.patch(
    `${ROUTE}/possible-causes/${code}?possibleCauses=${possibleCauses}`
  );
  return result.data.alarm;
}

//Patch Possible Solutions
export async function patchPossibleSolutions(
  code: string,
  possibleSolutions: string
): Promise<AlarmDetails> {
  const result = await api.patch(
    `${ROUTE}/possible-solutions/${code}?possibleSolutions=${possibleSolutions}`
  );
  return result.data.alarm;
}

//Patch Inspection Procedures
export async function patchInspectionProcedures(
  code: string,
  inspectionProcedures: File
) {
  const formData = new FormData();
  formData.append("inspectionProcedures", inspectionProcedures);
  await api.patch(`${ROUTE}/inspection-procedures/${code}`, formData);
}

//Post Criar Alarme
export async function postCriarMatrizAlarme(
  code: string,
  name: string,
  type: string,
  severity: number,
  message: string,
  causes: string,
  solutions: string
): Promise<AlarmDetails> {
  const data = {
    code: code,
    name: name,
    type: type,
    severity: severity,
    message: message,
    causes: causes,
    solutions: solutions,
  };

  const result = await api.post(`${ROUTE}/create`, data);
  return result.data.alarm;
}

export async function getCurrentAlarms(
  ropInputId: string
): Promise<CurrentAlarms> {
  const result = await api.get(`${ROUTE}/current/${ropInputId}`);
  return result.data;
}

// Get All Alarms
export async function getAllAlarms(
  code: string,
  name: string,
  type: string,
  severity: number
) {
  const config: AxiosRequestConfig = {
    params: {
      code: code,
      name: name,
      type: type,
      severity: severity,
    },
  };
  const result = await api.get(`${ROUTE}/all-alarms`, config);

  return result.data;
}
